import { render, staticRenderFns } from "./SandboxTab.vue?vue&type=template&id=e44e0f30&"
import script from "./SandboxTab.vue?vue&type=script&lang=js&"
export * from "./SandboxTab.vue?vue&type=script&lang=js&"
import style0 from "./SandboxTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports